import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function AccountStatusUpsert(param: any) {

    console.log(param)
    let [accountStatus, setAccountStatus] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            accountStatus = param?.editDataDawer
            setAccountStatus(accountStatus)
        }
    }

    const onSave = () => {
        systemFormatsList.saveStatusAccount(accountStatus).then((respond: any) => {
            CommonUtilities.showToastDawer('Account Status Saved', 'Success')
        })
    }

    return (<>
        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll' size={800}>

            <div className="pull-right ws-5 box full-height-vh" >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add  Account Status </h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="row-fluid">
                        <div className="ws-12">
                            <div className="form-format">
                                <label className="control-label">Account Status UseID  </label>
                                <div className="label-entries">
                                    <input type="number" placeholder="Account Status Use ID" data-ng-model="accountStatus.acctStatusUseID" id="acctStatusUseID" ng-disabled="IsDisabled" name="acctStatusUseID" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" >Account Status Name</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Account Status Name" data-ng-model="accountStatus.acctStatusName" id="acctStatusName" name="acctStatusName" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">
                                    Account Status Short Code
                                </label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Account Status Short Code" data-ng-model="accountStatus.acctStatusShortCode" id="acctStatusShortCode" name="acctStatusShortCode" />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12 mt">
                            <div className="ws-6">

                                <div className="mbl">
                                    RecMYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="accountStatus.recMYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatus.recMYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatus.recMYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    PublYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="accountStatus.publYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatus.publYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatus.publYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    MechYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="accountStatus.mechYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatus.mechYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatus.mechYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    ApprovalYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="accountStatus.approvalYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatus.approvalYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatus.approvalYN =='1'">No</span>
                                    </label>
                                </div>
                            </div>

                            <div className="ws-6 ">

                                <div className="mbl">
                                    ControlRptYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="accountStatus.controlRptYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatus.controlRptYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatus.controlRptYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    EmailYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="accountStatus.emailYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatus.emailYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatus.emailYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    AutoLTD
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="accountStatus.autoLTD" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatus.autoLTD=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatus.autoLTD =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    IsDefault
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="accountStatus.isDefault" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatus.isDefault=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatus.isDefault =='1'">No</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}